import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandPersonio(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <path
        d="M11.603 12.64c-.763 2.72-1.394 5.005-1.44 5.315-.125.835-1.358.701-1.288-.147.029-.254.54-2.136 1.165-4.373-.883.411-1.61.677-2.058.733-.608.1-1.12-.248-1.069-.776a.651.651 0 0 1 .927-.515c.384-.055 1.37-.46 2.664-1.131.648-2.306 1.32-4.664 1.656-5.836.267-.79 1.44-.456 1.245.356-.399 1.392-.861 3.014-1.31 4.603.56-.32 1.151-.682 1.745-1.067 3.235-2.092 5.44-4.092 5.885-5.367.16-.48.044-.696-.192-.88-.567-.44-2.31-.494-5.503.672C9.246 5.973 4.19 9.363 3.71 11.131c.219.02.459 0 .63.173a.653.653 0 0 1-.17 1.078c-.724.258-2.017-.29-1.739-1.462.32-1.509 2.383-3.162 4.053-4.291a34.374 34.374 0 0 1 7.107-3.62c2.283-.836 5.306-1.591 6.741-.48.67.524.914 1.28.685 2.12-.295 1.095-1.59 3.025-6.093 5.993a47.954 47.954 0 0 1-3.32 1.998Zm-7.82 8.01h17.089v1.192H3.784V20.65ZM16.08 17.94c.126-.471-.116-.945-.54-1.058-.425-.113-.871.178-.996.65-.126.47.117.944.54 1.057.425.113.871-.177.996-.649Z"
        fill="#000"
      />
    </BaseIcon>
  );
}
